import { Modules } from '../../util/modules'
import { RouteConfig } from 'vue-router'
import { businessRouteNames } from '@/routes/constants/location'

const BusinessPage = () =>
  import('@/pmd/pages/business/components/list/BusinessList.vue')

export const businessRoute: RouteConfig[] = [
  {
    path: 'businesses/:business_id?',
    name: businessRouteNames.default,
    component: BusinessPage,
    meta: { translations: [Modules.Business, Modules.Task] },
  },
]

